export default __webpack_public_path__ + "static/thirdStep-d7673c7a4df5a993ab565e6618958449.png";